export type MapObstacleKind = 'building' | 'fence' | 'tree' | 'prop';
export type MapObstacleVariant =
  | 'chapel'
  | 'burning-house'
  | 'ruined-house'
  | 'storehouse'
  | 'wooden-fence'
  | 'dead-tree'
  | 'village-well'
  | 'broken-cart'
  | 'gallows';

export type MapObstacle = {
  id: string;
  kind: MapObstacleKind;
  variant: MapObstacleVariant;
  x: number;
  y: number;
  width: number;
  height: number;
};

export type CampfireSpot = {
  id: string;
  x: number;
  y: number;
  radius: number;
};

export const PLAYER_SPAWN = { x: 900, y: 1400 } as const;

export const MAP_OBSTACLES: MapObstacle[] = [
  { id: 'chapel', kind: 'building', variant: 'chapel', x: 900, y: 1000, width: 140, height: 150 },
  { id: 'east-house', kind: 'building', variant: 'burning-house', x: 1120, y: 1299, width: 124, height: 102 },
  { id: 'south-house', kind: 'building', variant: 'burning-house', x: 690, y: 1699, width: 124, height: 102 },
  { id: 'west-ruin', kind: 'building', variant: 'ruined-house', x: 430, y: 1460, width: 148, height: 96 },
  { id: 'south-storehouse', kind: 'building', variant: 'storehouse', x: 1280, y: 2100, width: 174, height: 116 },

  { id: 'northwest-fence', kind: 'fence', variant: 'wooden-fence', x: 655, y: 1360, width: 220, height: 20 },
  { id: 'northeast-fence', kind: 'fence', variant: 'wooden-fence', x: 1055, y: 1515, width: 226, height: 20 },
  { id: 'west-fence', kind: 'fence', variant: 'wooden-fence', x: 548, y: 1870, width: 20, height: 220 },
  { id: 'east-fence', kind: 'fence', variant: 'wooden-fence', x: 1218, y: 1765, width: 20, height: 230 },
  { id: 'south-fence', kind: 'fence', variant: 'wooden-fence', x: 875, y: 2160, width: 270, height: 20 },
  { id: 'chapel-yard-fence', kind: 'fence', variant: 'wooden-fence', x: 690, y: 1100, width: 180, height: 20 },
  { id: 'east-yard-fence', kind: 'fence', variant: 'wooden-fence', x: 1265, y: 1270, width: 20, height: 170 },
  { id: 'ruin-yard-fence', kind: 'fence', variant: 'wooden-fence', x: 400, y: 1585, width: 170, height: 20 },

  { id: 'tree-northwest', kind: 'tree', variant: 'dead-tree', x: 755, y: 1195, width: 42, height: 38 },
  { id: 'tree-center-east', kind: 'tree', variant: 'dead-tree', x: 1038, y: 1390, width: 44, height: 40 },
  { id: 'tree-southwest', kind: 'tree', variant: 'dead-tree', x: 820, y: 1585, width: 42, height: 38 },
  { id: 'tree-east', kind: 'tree', variant: 'dead-tree', x: 1390, y: 1580, width: 46, height: 42 },
  { id: 'tree-deep-south', kind: 'tree', variant: 'dead-tree', x: 1080, y: 2290, width: 46, height: 42 },
  { id: 'tree-north-road', kind: 'tree', variant: 'dead-tree', x: 1110, y: 760, width: 44, height: 40 },
  { id: 'tree-west-field', kind: 'tree', variant: 'dead-tree', x: 315, y: 1940, width: 48, height: 44 },

  { id: 'village-well', kind: 'prop', variant: 'village-well', x: 970, y: 1600, width: 62, height: 48 },
  { id: 'broken-cart', kind: 'prop', variant: 'broken-cart', x: 820, y: 1940, width: 112, height: 50 },
  { id: 'east-gallows', kind: 'prop', variant: 'gallows', x: 1360, y: 1435, width: 74, height: 50 },
];

export const CAMPFIRE_SPOTS: CampfireSpot[] = [
  { id: 'village-center', x: 800, y: 1425, radius: 92 },
  { id: 'south-road', x: 1015, y: 1870, radius: 92 },
  { id: 'chapel-yard', x: 1165, y: 1080, radius: 88 },
  { id: 'deep-south', x: 650, y: 2260, radius: 96 },
];

export function isPointBlocked(
  x: number,
  y: number,
  padding = 0,
  obstacles: readonly MapObstacle[] = MAP_OBSTACLES,
): boolean {
  return obstacles.some((obstacle) => (
    x >= obstacle.x - obstacle.width / 2 - padding
    && x <= obstacle.x + obstacle.width / 2 + padding
    && y >= obstacle.y - obstacle.height / 2 - padding
    && y <= obstacle.y + obstacle.height / 2 + padding
  ));
}
